import { colors } from '@sweep-io/sweep-design';
import { getObjectTypeColor } from '../../sweep-canvas/helpers/getObjectTypeColor';

export const getColorForTemplateCard = (objectName?: string) =>
  (colors[getObjectTypeColor(objectName)?.leadingColorName as keyof typeof colors] as any)[100] ||
  colors.blue[100];
